// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'help';

export const Component = () => (
  <g fill='none' stroke='currentColor'>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M6.75 6.75a2.25 2.25 0 1 1 3 2.122A1.125 1.125 0 0 0 9 9.933v.754'
    />
    <path d='M9 13.5a.281.281 0 1 1 0-.563m0 .563a.281.281 0 1 0 0-.563' />
    <path d='M9 17.438A8.438 8.438 0 1 0 9 .561a8.438 8.438 0 0 0 0 16.875z' />
  </g>
);

export const viewBox = '0 0 18 18';
